<template>
  <Content id="inspectExceptionLog">
    <div slot="search">
      <Form :label-width="60" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="条形码"><el-input v-model="search.barCode" :maxlength="13" :clearable="true" @input="toInt()"/></FormItem></Col>
          <Col><FormItem label="姓名" :label-width="45"><el-input v-model="search.name" :maxlength="50" :clearable="true"/></FormItem></Col>
          <Col><FormItem label="证件号码" :label-width="75"><el-input v-model="search.idCard" :maxlength="18" :clearable="true" style="width: 100%;"/></FormItem></Col>
          <Col>
            <FormItem label="体检任务"  prop="taskId" :label-width="75">
              <el-select v-model.trim="search.taskId" placeholder="体检任务"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="min-width: 350px;">
                <el-option v-for="item in taskList" :key="item.value" :label="item.label" :value="item.value"
                           @click.native="handleTaskChange(item)" style="min-width: 350px;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem  label="学校名称"  prop="schoolId" :label-width="75">
              <el-select v-model.trim="search.schoolId" placeholder="学校名称"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false"
                         style="width: 100%;" @change="changeSchool">
                <el-option v-for="item in schoolsList" :key="item.value" :label="item.label" :value="item.value"
                           @click.native="handleShoolChange(item)" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="年级"  prop="gradeId" :label-width="45">
              <el-select v-model.trim="search.gradeId" placeholder="年级"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false"
                         style="width: 100%;" @change="changeGrade">
                <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleGradeChange(item)" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="班级"  prop="classesId" :label-width="45">
              <el-select v-model.trim="search.classesId" placeholder="班级"
                         clearable filterable size="small" transfer="true"
                         style="width: 100%;" :popper-append-to-body="false">
                <el-option v-for="item in classesList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleClassChange(item)" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="日期">
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="起始日期" format="yyyy-MM-dd"
                          v-model="search.startDate" @on-change="changestart"/>
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="结束日期" format="yyyy-MM-dd"
                          v-model="search.endDate" @on-change="changeend"/>
            </FormItem>
          </Col>
          <Col><div style="display:flex;">&nbsp;&nbsp;<Button type="primary" @click="query">查询</Button></div></Col>
        </Row>
      </Form>
    </div>

    <el-table :data="dataList" style="width: 100%;" :header-cell-style="{ background: '#f8f8f9', color: '#515a6e', 'text-align': 'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow"
              highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed align="center" prop="barCode" label="条形码" min-width="130"/>
      <el-table-column fixed align="center" prop="name" label="姓名" min-width="100"/>
      <el-table-column align="center" prop="idCard" label="证件号码" min-width="180"/>
      <el-table-column align="center" prop="schoolName" label="学校" min-width="200"/>
      <el-table-column align="center" prop="gradeName" label="年级" min-width="110"/>
      <el-table-column align="center" prop="classesName" label="班级" min-width="150"/>
      <el-table-column align="center" prop="content" label="内容" min-width="150"/>
      <el-table-column align="center" prop="remarks" label="备注" min-width="150"/>
<!--      <el-table-column align="center" prop="recordTime" label="录入时间" min-width="160"/>-->
<!--      <el-table-column align="center" prop="reportDate" label="报告时间" min-width="160"/>-->
      <el-table-column align="center" prop="createTime" label="拉取时间" min-width="160"/>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="200" id="elPopoverVisible">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="preview(row)">预览报告</el-button>
          <el-button type="text" size="medium" @click="download(row)">下载报告</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal v-model="dialogVisible" width="50%" title="预览" :styles="{'top':'60px'}" :footerHide="true">
      <div :style="{'max-height':maxHeight,'overflow-y':'auto'}">
        <img :style="{'display':'block','width':'100%'}" :src="dialogImageUrl">
      </div>
    </Modal>

  </Content>
</template>
<script>
import {_page} from "@/services/operationRecord/inspectExceptionLog.js";
import {mixins} from "@/mixins";
import {_classesList, _gradesList} from "@/services/studentManage/studentManage";
import PrintBarCode from "@/views/screening/screeningDataInfo/PrintBarCode.vue";
import TaskDetailEdit from "@/views/preScreening/taskDetail/TaskDetailEdit.vue";
export default {
  name: "InspectExceptionLog",
  components: {TaskDetailEdit, PrintBarCode},
  mixins: [mixins],
  computed: {

  },
  data() {
    return {
      tableHeight: 0,
      maxHeight: 0,
      currentRowIndex: null,
      dialogVisible: false,
      dialogImageUrl: "",
      search: {
        barCode:"",
        taskId:"",
        schoolId:"",
        gradeId:"",
        classesId:"",
        name:"",
        idCard:"",
      },
      taskList: [],
      schoolList: [],
      gradeList: [],
      classesList: [],
      dataList: [],
      pageList:{
        currentPage:1,
        pageSize:10,
        total: 0,
      },
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList();
      this.applyTaskList();
      this.applySchoolsList();
    }
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
      this.maxHeight = `${height - 220}px`;
    },
    changeSchool(schoolId) {
      if (!schoolId) {
        this.gradeList = [];
        this.classesList = [];
        this.search.gradeId = "";
        this.search.classesId = "";
        return;
      }
      _gradesList({schoolId: schoolId}).then(res => {
        this.search.schoolId = schoolId;
        this.search.gradeId = "";
        this.search.classesId = "";
        if (res.errcode === 1 && res.data) {
          this.gradeList = res.data;
        } else {
          this.gradeList = []
        }
      })
    },
    changeGrade(gradeId) {
      if (!gradeId) {
        this.classesList = [];
        this.search.classesId = "";
        return;
      }
      _classesList({schoolId:this.search.schoolId, gradeId: gradeId}).then(res => {
        this.search.gradeId = gradeId;
        this.search.classesId = "";
        if (res.errcode === 1 && res.data) {
          this.classesList = res.data;
        } else {
          this.classesList = []
        }
      })
    },
    handleTaskChange(item) {
      this.search.taskId = item.id;
    },
    handleShoolChange(item) {
      this.search.schoolId = item.value;
    },
    handleGradeChange(item) {
      this.search.gradeId = item.id;
    },
    handleClassChange(item) {
      this.search.classesId = item.id;
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        if (res.errcode == 1){
          this.dataList = res.data.records;
          this.pageList.total = res.data.total;
        } else {
          this.$message.error(res.errmsg)
        }
      }).catch(() => {});
    },
    preview(row){
      this.dialogImageUrl = row.reportJpg;
      this.dialogVisible = true;
    },
    download(row){
      const loading = this.$loading({
        lock: true,
        text: '正在下载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try{
        const link = document.createElement('a');
        link.href = row.reportJpg;
        link.download = (row.barCode + "_" + row.name) || 'downloaded-image.jpg'; // 设置download属性很重要
        document.body.appendChild(link); // 将链接添加到DOM中
        link.click(); // 模拟点击
        document.body.removeChild(link); // 移除链接
        loading.close();
      }catch (e) {
        loading.close();
        console.error('下载失败:', e);
      }finally {
        loading.close();
      }
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    changestart(e) {
      this.search.startDate = e
    },
    changeend(e) {
      this.search.endDate = e
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    toInt(){
      if(this.search.barCode){
        this.search.barCode = (this.search.barCode + "").replace(/[^\d]+/g, '');
        this.search.barCode = (this.search.barCode + "").replace('.', '');
        this.search.barCode = (this.search.barCode + "").replace(/\./g, '');
        this.search.barCode = (this.search.barCode + "").replace(/\\./g, '');
        this.search.barCode = (this.search.barCode + "").replace('$#$', '');
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 5px;vertical-align: top;zoom: 1;}
/deep/ .el-dialog__body {padding: 5px 20px;}
/deep/ .el-input__inner {height: 30px;line-height: 30px;}
/deep/ .el-input__icon{line-height: 30px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}
/deep/ .el-table .el-table__cell {padding: 10px 0;}

</style>
